import { Injectable, inject } from '@angular/core';
import { CrudService } from '@shared/modules/crud/crud.service';
import { MessageService } from './message.service';

export type NotificationType = 'externalQuestions' | 'newConsorcista' | 'system' | 'providers';

export interface Notification {
    uid?:string;
    title: string;
    content: string;
    createdAt: Date;
    read: boolean;
    data: any;
    type?: NotificationType;
}

@Injectable({
    providedIn: 'root',
})
export class NotificationService extends MessageService<Notification> {
    override model = 'users';
    subcollection = 'notifications';

    createPush(message: Notification, userId: string, type: string) {
        this.crudService.setModel(
            'users/' + userId + '/accounts/' + type + '/' + this.subcollection
        );
        const id = this.idService.generateId();
        return this.crudService.add(message);
    }

    getAllNotifications(userId: string, type: string) {
          this.crudService.setModel(
            'users/' + userId + '/accounts/' + type + '/' + this.subcollection
        );
        return this.crudService.findAll<any>();
    }
    
    getAllnewNotifications(userId: string, type: string) {
          this.crudService.setModel(
            'users/' + userId + '/accounts/' + type + '/' + this.subcollection
        );
         const filter:any  = [{
                field: 'read',
                operator: '==', 
                value: false,
            }           
        ];
        return this.crudService.findWhere<Notification>(filter, []);
    }

    updateRead(userId: string, type: string, id:string) {
          this.crudService.setModel(
            'users/' + userId + '/accounts/' + type + '/' + this.subcollection + '/' + id
        );
        return this.crudService.update('', { read: true });
    }
    updateAllRead(userId: string, type: string, collection: Notification[]) {
        this.crudService.setModel(
            'users/' + userId + '/accounts/' + type + '/' + this.subcollection
        );
        return this.crudService.updateOnlyMany(collection.map(notification => ({...notification, read: true})));
    }
}
